module.exports = __webpack_public_path__ + "img/why-sc-bg.26196bfb.jpg";